<template>
  <div class="bill-refunds-table">
    <div class="bill-refunds-table__header">
      <div
        class="bill-refunds-table__header-col"
        v-html="$t('bill-refunds-table.header.date')"
      ></div>
      <div
        class="bill-refunds-table__header-col"
        v-html="$t('bill-refunds-table.header.operation-id')"
      ></div>
      <div
        class="bill-refunds-table__header-col"
        v-html="$t('bill-refunds-table.header.amount')"
      ></div>
      <div
        class="bill-refunds-table__header-col bill-refunds-table__header-col--status"
        v-html="$t('bill-refunds-table.header.status')"
      ></div>
    </div>
    <div class="bill-refunds-table__body">
      <div
        class="bill-refunds-table__row"
        v-for="refund in refunds"
        :key="`refund-${refund.OperationID}`"
      >
        <div class="bill-refunds-table__date-time">
          <div class="bill-refunds-table__date-time-date">
            {{ getRefundDate(refund) }}
          </div>
          <div class="bill-refunds-table__date-time-time">
            {{ getRefundTime(refund) }}
          </div>
        </div>
        <div class="bill-refunds-table__pan">
          {{ refund.operation_id }}
        </div>
        <div class="bill-refunds-table__amount">
          {{ getRefundAmount(refund) }}
        </div>
        <div class="bill-refunds-table__status">
          <transaction-status
            :status-id="refund.operation_status_id"
          ></transaction-status>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import TransactionStatus from '@vue-app/components/transaction/TransactionStatus.vue'

export default {
  name: 'CompanyBillRefundsTable',
  components: { TransactionStatus },
  props: {
    refunds: {
      type: Array,
      default() {
        return []
      },
    },
  },
  computed: {},
  methods: {
    getRefundDate(refund) {
      try {
        return moment(refund.dt).format('YYYY.MM.DD')
      } catch (e) {
        return ''
      }
    },

    getRefundTime(refund) {
      try {
        return moment(refund.dt).format('HH:mm:ss')
      } catch (e) {
        return ''
      }
    },

    getRefundAmount(refund) {
      try {
        return (parseInt(refund.sm) / 100).toLocaleString()
      } catch (e) {
        return ''
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.bill-refunds-table {
  &__header {
    padding: 16px 25px 14px;
    background: #ffffff;
    border-radius: 20px 20px 0 0;
    border-bottom: 1px solid #eff2f8;
    display: grid;
    grid-template-columns: repeat(2, 1fr) 2fr 1fr;
    column-gap: 10px;

    &-col {
      display: flex;
      align-items: center;

      font-weight: 500;
      font-size: 12px;
      line-height: 16px;
      text-transform: uppercase;
      color: #909cb0;
      opacity: 0.7;

      &--status {
        display: flex;
        justify-content: center;
      }
    }
  }

  &__body {
    background: #ffffff;
    border-radius: 0 0 20px 20px;
    padding-bottom: 30px;
  }

  &__row {
    display: grid;
    grid-template-columns: repeat(2, 1fr) 2fr 1fr;
    column-gap: 10px;
    border-bottom: 1px solid #eff2f8;
    padding: 22px 25px;

    & > div {
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
  }

  &__date-time {
    &-date {
      font-weight: 600;
      font-size: 12px;
      line-height: 16px;
      color: #27365b;
      opacity: 0.7;
    }

    &-time {
      font-weight: 500;
      font-size: 12px;
      line-height: 16px;
      color: rgba(#27365b, 0.7);
    }
  }

  &__pan {
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
    color: #27365b;
    opacity: 0.7;
  }

  &__amount {
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
    color: #27365b;
    opacity: 0.7;
  }

  &__commission,
  &__currency {
    font-weight: 500;
    font-size: 12px;
    line-height: 18px;
    color: #585f6d;
    opacity: 0.7;
  }

  &__status {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
